var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSoundOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3888 4.84628C17.3889 4.69658 17.3488 4.54955 17.2726 4.42019C17.1965 4.29084 17.087 4.1838 16.9554 4.10999C16.8238 4.03618 16.6748 3.99825 16.5235 4.00006C16.3723 4.00188 16.2242 4.04338 16.0945 4.12032L7.74858 9.0734H4.5648C3.14732 9.0734 2 10.2072 2 11.6117V18.3839C2 19.7867 3.14561 20.9222 4.5648 20.9222H7.74858L16.0927 25.8787C16.2225 25.956 16.3708 25.9979 16.5223 25.9999C16.6738 26.002 16.8231 25.9641 16.955 25.8902C17.0869 25.8164 17.1965 25.7092 17.2727 25.5796C17.349 25.45 17.389 25.3027 17.3888 25.1527V4.84628ZM24.5822 14.9927L26.3889 16.7794C26.7253 17.1122 26.7254 17.6556 26.3891 17.9884V17.9884C26.0578 18.3163 25.5244 18.3164 25.193 17.9886L23.3734 16.1891L21.5538 17.9886C21.2224 18.3164 20.6889 18.3163 20.3577 17.9884V17.9884C20.0213 17.6556 20.0214 17.1122 20.3579 16.7794L22.1645 14.9927L20.3579 13.206C20.0214 12.8733 20.0213 12.3299 20.3577 11.997V11.997C20.6889 11.6692 21.2224 11.6691 21.5538 11.9968L23.3734 13.7963L25.1946 11.9965C25.526 11.669 26.0593 11.6694 26.3903 11.9973V11.9973C26.726 12.3301 26.7257 12.8729 26.3896 13.2053L24.5822 14.9927Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoundOff);
export default __webpack_public_path__ + "static/media/soundOff.fa7c64d1adf88d4e44e259b2bdbf4393.svg";
export { ForwardRef as ReactComponent };